export default function appendScript(_attributes) {
  const script = document.createElement('script');
  const attributes = {
    type: 'text/javascript',
    async: true,
    ..._attributes
  };
  for (const [key, value] of Object.entries(attributes)) {
    if (key === 'dataset') {
      for (const [datasetKey, datasetValue] of Object.entries(value)) {
        script[key][datasetKey] = datasetValue;
      }
    } else {
      // @ts-ignore
      script[key] = value;
    }
  }
  const appendTarget = document.getElementsByTagName('head')[0] || document.documentElement;
  appendTarget.appendChild(script);
}